import React from "react";

export const LoadingIcon = () => (
  <div className="flex items-center justify-center m-2">
    <svg
      width="50px"
      height="50px"
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        strokeWidth="5"
        stroke="#FB512D"
      >
        <animate
          attributeName="stroke-dasharray"
          from="1, 200"
          to="200, 1"
          dur="1.5s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="stroke-dashoffset"
          from="0"
          to="-251"
          dur="1.5s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  </div>
);
